<template>
  <div>
    <div
      class="keyboard-row"
      :class="rowClass(i)"
      v-for="(r, i) of rows"
      :key="i"
    >
      <keyboard-key
        v-for="c of r"
        :key="c"
        :value="c"
        @addchar="handleKeyDown"
        @backspace="handleDelete"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import KeyboardKey from "./KeyboardKey.vue";

export default defineComponent({
  components: { KeyboardKey },
  props: { modelValue: { type: String, default: "" } },
  data: function () {
    return {
      rows: [] as any[],
    };
  },
  created: function () {
    this.rows[0] = "qwertyuiop".split("");
    this.rows[0].push(String.fromCharCode(8592));
    this.rows[1] = "asdfghjkl'".split("");
    this.rows[2] = "zxcvbnm-".split("");
  },
  methods: {
    rowClass(i: number) {
      return "row-" + i;
    },
    handleKeyDown(char: Event) {
      this.$emit("update:modelValue", this.modelValue + char);
    },
    handleDelete() {
      this.$emit("update:modelValue", this.modelValue.slice(0, -1));
    },
  },
});
</script>
